<template>
	<div class="ModuleBox">
		<div class="ModuleBoxBackground"></div>
		<div class="ModuleBoxBody">
			<div class="ModuleBoxBodyBody">
		
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
